import { Link } from "react-router-dom";
import StoreLoadingSkeleton from "../../../../StoreComponents/StoreLoadingSkeleton";
import { CardGrid } from "../components/CardGrid";
import { PreviewHeader } from "../components/Header";
import PreviewWidgetWrapper from "../components/PreviewWidgetWrapper";
import { useFetchPopularProduct } from "./data";
import { useRef, useEffect } from "react";
import { useInView } from "framer-motion";
import PreviewContainer from "../components/PreviewContainer";
import { defaultPreviewLazyLoadConfig } from "../../../../../utils/lazyLoadConfig";
import ProductCard from "../../../../StoreComponents/StoreCard.tsx/ProductCard";
import { useLinkPrefix } from "../../../../../utils/hooks/useLinkPrefix";

const MAXPAGE = 4;

interface PopularPreviewProps {
  pageSize?: number;
  brandIds?: number[];
  isFiniteScroll?: boolean; // default is infinite scroll
  title?: string;
  subtitle?: string;
}
const PopularPreview = (props: PopularPreviewProps) => {
  const { brandIds, isFiniteScroll, pageSize = 20 } = props;
  const ref = useRef(null);

  const { linkPrefix } = useLinkPrefix();
  const widgetInView = useInView(ref, defaultPreviewLazyLoadConfig);
  const widgetEndRef = useRef<any>(null);

  const widgetEndInView = useInView(widgetEndRef);
  const { data, loading, fetchInit, fetchMore, loadingMore, hasMore, page } =
    useFetchPopularProduct({
      brandIds,
      pageSize,
      autoInitFetch: false,
    });

  useEffect(() => {
    if (widgetInView) {
      fetchInit();
    }
  }, [widgetInView, fetchInit]);

  useEffect(() => {
    if (
      !isFiniteScroll &&
      widgetEndInView &&
      !loading &&
      !loadingMore &&
      hasMore
    ) {
      if (page < MAXPAGE) {
        fetchMore();
      }
    }
  }, [
    isFiniteScroll,
    widgetEndInView,
    loading,
    loadingMore,
    hasMore,
    fetchMore,
    page,
  ]);

  if (!loading && data.length === 0) {
    return null;
  }

  return (
    <PreviewWidgetWrapper ref={ref}>
      <PreviewContainer>
        {loading ? (
          <StoreLoadingSkeleton header />
        ) : (
          <>
            <PreviewHeader
              title={props.title || "Popular products"}
              linkTo={linkPrefix + "/popular"}
              subtitle={props.subtitle || "Shop trending products"}
              indicator="grey"
            />

            <CardGrid>
              {data.map((p) => (
                <ProductCard
                  key={`trending:${p.stacklineSku}`}
                  LinkComponent={Link}
                  product={p}
                />
              ))}
            </CardGrid>
          </>
        )}
        {loadingMore ? (
          <div style={{ marginTop: 20 }}>
            <StoreLoadingSkeleton header={false} />
          </div>
        ) : null}
        <div className="end_detect" ref={widgetEndRef}></div>
      </PreviewContainer>
    </PreviewWidgetWrapper>
  );
};

export default PopularPreview;
